import { render, staticRenderFns } from "./SpeedrunMilestoneSingle.vue?vue&type=template&id=6dc89033"
import script from "./SpeedrunMilestoneSingle.vue?vue&type=script&lang=js"
export * from "./SpeedrunMilestoneSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports